import { ORG_ROUTE_SEGMENTS, ROOT_ROUTE_SEGMENTS } from "./routesConstant";

const orgBaseRoute = (orgId) => `/${ROOT_ROUTE_SEGMENTS.ORGANIZATION}/${orgId}`;

export const buildPath = {
  builderUser: () => `/${ROOT_ROUTE_SEGMENTS.BUILDER_USER}`,

  userService: () => `/${ROOT_ROUTE_SEGMENTS.USER_SERVICE}`,

  smTemplates: () => `/${ROOT_ROUTE_SEGMENTS.SM_TEMPLATES}`,

  screenTemplates: () => `/${ROOT_ROUTE_SEGMENTS.SCREEN_TEMPLATES}`,

  themeList: () => `/${ROOT_ROUTE_SEGMENTS.THEME}`,

  themeEditor: ({ themeId }) => `/${ROOT_ROUTE_SEGMENTS.THEME}/${themeId}`,

  charts: () => `/${ROOT_ROUTE_SEGMENTS.CHARTS}`,

  chartEditor: () => `/${ROOT_ROUTE_SEGMENTS.CHART_EDITOR}`,

  prompt: () => `/${ROOT_ROUTE_SEGMENTS.PROMPT}`,

  proxy: () => `/${ROOT_ROUTE_SEGMENTS.PROXY_ROUTES}`,

  releases: () => `/${ROOT_ROUTE_SEGMENTS.RELEASES}`,

  UserManagement: () => `/${ROOT_ROUTE_SEGMENTS.USER_MANAGEMENT}`,

  clusterManager: () => `/${ROOT_ROUTE_SEGMENTS.CLUSTER_MANAGER}`,

  metrics: () => `/${ROOT_ROUTE_SEGMENTS.METRICS}`,

  organizationList: () => `/${ROOT_ROUTE_SEGMENTS.ORGANIZATION}`,

  orgRoot: ({ orgId }) => orgBaseRoute(orgId),

  orgStructure: ({ orgId }) => `${orgBaseRoute(orgId)}/${ORG_ROUTE_SEGMENTS.STRUCTURE}`,

  orgUsers: ({ orgId }) => `${orgBaseRoute(orgId)}/${ORG_ROUTE_SEGMENTS.USERS}`,

  orgGroups: ({ orgId }) => `${orgBaseRoute(orgId)}/${ORG_ROUTE_SEGMENTS.GROUP_USERS}`,

  orgThemeList: ({ orgId }) => `${orgBaseRoute(orgId)}/${ORG_ROUTE_SEGMENTS.THEME}`,

  orgThemeEditor: ({ orgId, themeId }) => `${orgBaseRoute(orgId)}/${ORG_ROUTE_SEGMENTS.THEME}/${themeId}`,

  orgApps: ({ orgId }) => `${orgBaseRoute(orgId)}/${ORG_ROUTE_SEGMENTS.APPLICATIONS}`,

  orgUserRoles: ({ orgId }) => `${orgBaseRoute(orgId)}/${ORG_ROUTE_SEGMENTS.ROLES}`,

  orgMonitor: ({ orgId }) => `${orgBaseRoute(orgId)}/${ORG_ROUTE_SEGMENTS.MONITOR}`,

  orgUserLogs: () => `/${ROOT_ROUTE_SEGMENTS.USER_LOGS}`
};
